import * as types from "../constants/ActionTypes";
import * as s3Api from "./../api/s3Api.js";
import * as localStorageConstants from "../constants/localStorageConstants";
import { setProceedUnsupportedBrowser } from "../storage/localStorage";
import { notifyDatadogWithError } from "../components/ErrorBoundary.js";

export const fetchBranding = () => async (dispatch, getState) => {
  try {
    const data = await s3Api.fetchBranding();

    dispatch({
      type: types.FETCH_BRANDING_RECEIVED,
      data,
      toSave: {
        [localStorageConstants.BRANDING]: { ...data }
      }
    });
  } catch (error) {
    notifyDatadogWithError(error);
    dispatch({
      type: types.FETCH_BRANDING_FAILURE
    });
  }
};

export const proceedWithUnsupportedBrowser = isDeprecatedBrowser => dispatch => {
  dispatch({
    type: types.PROCEED_UNSUPPORTED_BROWSER
  });

  return Promise.resolve(setProceedUnsupportedBrowser(isDeprecatedBrowser));
};
